export type TideCalibration = {
    source: 'harmonic-msl'; quality: 'regional-estimate'; qualified: true;
    evidenceId: string; constituentSha256: string; offsetToOdnM: number;
    chartDatumOdnM: number; station: string; validFrom: string; validUntil: string;
    minOdnM: number; maxOdnM: number;
};
export function qualifiedTideHeight(mslM: number, hash: string, calibration: TideCalibration | null, utcMs: number): number | null {
    if (!calibration || calibration.source !== 'harmonic-msl' || calibration.qualified !== true
        || !/^[a-f0-9]{64}$/.test(hash) || hash !== calibration.constituentSha256
        || !Number.isFinite(mslM) || !Number.isFinite(utcMs) || !Number.isFinite(calibration.offsetToOdnM)
        || utcMs < Date.parse(calibration.validFrom) || utcMs >= Date.parse(calibration.validUntil)
        || !Number.isFinite(Date.parse(calibration.validFrom)) || !Number.isFinite(Date.parse(calibration.validUntil))) return null;
    const height = mslM + calibration.offsetToOdnM;
    return height >= calibration.minOdnM && height <= calibration.maxOdnM ? height : null;
}
export function validateTideCalibration(value: unknown): TideCalibration | null {
    if (value === null) return null;
    if (!value || typeof value !== 'object') throw new Error('Invalid tide calibration');
    const c = value as TideCalibration;
    if (c.source !== 'harmonic-msl' || c.quality !== 'regional-estimate' || c.qualified !== true
        || typeof c.evidenceId !== 'string' || !/^[a-z0-9-]{1,80}$/.test(c.evidenceId)
        || typeof c.station !== 'string' || c.station.length > 100
        || !/^[a-f0-9]{64}$/.test(c.constituentSha256) || !Number.isFinite(c.offsetToOdnM) || Math.abs(c.offsetToOdnM) > 2
        || !Number.isFinite(c.chartDatumOdnM) || Math.abs(c.chartDatumOdnM) > 15
        || !Number.isFinite(c.minOdnM) || !Number.isFinite(c.maxOdnM) || c.minOdnM >= c.maxOdnM || c.minOdnM < -15 || c.maxOdnM > 15
        || !Number.isFinite(Date.parse(c.validFrom)) || !(Date.parse(c.validUntil) > Date.parse(c.validFrom))) throw new Error('Invalid tide calibration');
    return c;
}
